import Button from "@mui/material/Button";
import Container from "@mui/material/Container";
import CssBaseline from "@mui/material/CssBaseline";
import { Grid2 } from "@mui/material";
import Link from "@mui/material/Link";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import React, { useState } from "react";
import { Navigate } from "react-router-dom";
import "./styles.css";

import { Paths } from "components/common/navigation";
import log from "loglevel";

const Login = (props) => {
    const [form, setForm] = useState({
        username: "",
        password: "",
        showPassword: false,
    });

    const [hideMessages, setHideMessages] = useState(false);

    const onChange = (e) => {
        const { name, value } = e.target;
        setForm((prevForm) => ({
            ...prevForm,
            [name]: value,
        }));
        setHideMessages(true);
    };

    const showPassword = () => {
        setForm((prevForm) => ({
            ...prevForm,
            showPassword: !prevForm.showPassword,
            password: prevForm.showPassword ? prevForm.password : null,
        }));
        setHideMessages(true);
    };

    const submit = (e) => {
        e.preventDefault();
        props.login(form.username, form.showPassword ? form.password : undefined);
        setHideMessages(false);
    };

    const { authenticated, redirectPath, authStatus } = props;
    log.debug("login status", authenticated, redirectPath);

    if (authenticated) {
        return <Navigate to={redirectPath ? redirectPath : Paths.ADVERTISING} />;
    }

    return (
        (<div id="login-screen">
            <Container component="main" maxWidth="xs">
                <CssBaseline />
                <div>
                    <Typography component="h1" variant="h5">
                        Sign in
                    </Typography>
                    <form onSubmit={submit}>
                        <TextField
                            variant="outlined"
                            margin="normal"
                            required
                            fullWidth
                            label="Email Address"
                            placeholder="Email Address"
                            name="username"
                            autoComplete="username"
                            onChange={onChange}
                            value={form.username}
                            slotProps={{
                                inputLabel: {
                                    shrink: true
                                }
                            }}
                        />
                        {form.showPassword && (
                            <TextField
                                variant="outlined"
                                margin="normal"
                                required={form.showPassword}
                                fullWidth
                                name="password"
                                label="Password"
                                placeholder="Password"
                                type="password"
                                value={form.password}
                                onChange={onChange}
                                autoComplete="current-password"
                                slotProps={{
                                    inputLabel: {
                                        shrink: true
                                    }
                                }}
                            />
                        )}
                        <Button type="submit" variant="contained" color="primary">
                            Sign In
                        </Button>
                    </form>
                    <Grid2 container>
                        <Grid2 size="grow">
                            <Link href="#" variant="body2" onClick={showPassword}>
                                {!form.showPassword ? "Signin with password" : "Single Sign-On"}
                            </Link>
                        </Grid2>
                    </Grid2>
                    {!hideMessages && form.showPassword && authStatus === "FAILED" && (
                        <Grid2 container>
                            <Grid2 size={{
                                sm: "grow"
                            }}>
                                <p className="invalid-msg">Invalid username or password</p>
                            </Grid2>
                        </Grid2>
                    )}
                </div>
            </Container>
        </div>)
    );
};

export default Login;
